import mpx from '@mpxjs/core'
import { initSDK, init, query, hashQuery } from '@didi/webx-js'

initSDK({
  branch: 'passenger',
})

init({
  initOption: {
    config: {
      need_share_config: false,
      need_page_config: false,
      prod_key: 'quartz-mall',
      dchn: query().dchn || hashQuery().dchn || '',
    },
    quitInitProduct: false,
    env: process.env.BUILD_ENV === 'offline' ? 'offline' : 'online',
  },
}).then(res => {
  mpx.xpsid = res.xpsid || ''
  mpx.xpsidRoot = res.xpsid_root || ''
  mpx.xenv = res.xenv
})
